module.exports = __webpack_public_path__ + "static/media/mobile_dowj_ft.3e0e9998.png";